import { get } from 'lodash'
import { required } from 'utils/validation'

export default function(values = {}, props) {
  return {
    note: required(get(values, 'note')),
    helpers: {
      physical_recreation: required(get(values, 'helpers.physical_recreation')), // eslint-disable-line
      skills: required(get(values, 'helpers.skills')),
      service: required(get(values, 'helpers.service')),
      rp: props.isGold ? required(get(values, 'helpers.rp')) : undefined,
      aj: required(get(values, 'helpers.aj'))
    }
  }
}
